/* eslint-disable */
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import AsyncSelect from "react-select/async";
import { reactSelectStyle } from "Config/Config";

import {
  getData,
  uploadSingleFile,
  uploadMultipleFile,
  postData,
  putData,
  deleteData,
} from "utils/Gateway";
import * as url from "helper/UrlHelper";
import { useTranslation } from "react-i18next";

const SaveTimeModal = ({
  afterModalClose,
  selectedDayId,
  setselectedDayId,
}) => {
  const token = localStorage.getItem("token");
  const { t } = useTranslation(); // for translations
  const [dayNameString, setDayNameString] = useState("");

  /* hooks for validation */
  const [validation, setValidation] = useState([]);
  const [isSaving, setIsSaving] = useState(false);

  // Add new state for auto-fill configuration
  const [autoFillConfig, setAutoFillConfig] = useState({
    startTime: "09:00",
    endTime: "15:00",
    slotDuration: 30, // in minutes
    defaultLocation: "",
    defaultCompany: null,
    configMode: "new", // "new" or "existing"
  });

  const timeFormTemplate = {
    starttime: "",
    endtime: "",
    location: "",
    companyid: null,
    companyvalue: null,
  };

  const validationTemplate = {
    startTimeWarning: false,
    endTimeWarning: false,
    timeDiffWarning: false,
  };

  const [timeFormBlock, setTimeFormBlock] = useState([]);
  const [timeEmptyWarning, setTimeEmptyWarning] = useState(false);

  //add new time block
  const addNewTimeBlock = () => {
    setTimeEmptyWarning(false);
    setTimeFormBlock([...timeFormBlock, timeFormTemplate]);
    setValidation([...validation, validationTemplate]);
  };

  //delete time block
  const onDeleteBlock = async (timeData, index) => {
    if (timeData._id) {
      try {
        let requestUrl =
          url.API_BASE_URL +
          url.API_DELETE_TIME_AVAILIBILITY +
          `/${timeData._id}?token=${token}`;

        const response = await deleteData(requestUrl);

        if (response.status) {
          afterModalClose();
        }
      } catch (error) {
        console.log(error.message);
      }
    }

    setTimeFormBlock([
      ...timeFormBlock.slice(0, index),
      ...timeFormBlock.slice(index + 1),
    ]);
    setValidation([
      ...validation.slice(0, index),
      ...validation.slice(index + 1),
    ]);
  };

  // Async load options for clinics
  const loadCompanyOptions = async (inputValue) => {
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_ALL_COMPANY_LIST +
        `?token=${token}&filtername=${inputValue}`;

      const response = await getData(requestUrl);
      return response.data;
    } catch (error) {
      return [];
    }
  };

  //input changes handler
  const changeInputHandler = (index, field, value) => {
    // Reset validation for the specific block
    setValidation((prevValidation) =>
      prevValidation.map((blockValidation, i) =>
        index === i ? { ...validationTemplate } : blockValidation
      )
    );

    if (field === "starttime") {
      if (value) {
        const startTime = new Date(`2024-01-01T${value}`);
        const endTime = new Date(startTime.getTime() + 60 * 60 * 1000); // Adding 1 hour
        const formattedEndTime = `${String(endTime.getHours()).padStart(
          2,
          "0"
        )}:${String(endTime.getMinutes()).padStart(2, "0")}`;
        setTimeFormBlock(
          timeFormBlock.map((block, i) =>
            index === i
              ? { ...block, [field]: value, endtime: formattedEndTime }
              : block
          )
        );
      }
    } else if (field === "company") {
      if (value) {
        setTimeFormBlock(
          timeFormBlock.map((block, i) =>
            index === i
              ? { ...block, companyid: value.value, companyvalue: value }
              : block
          )
        );
      } else {
        setTimeFormBlock(
          timeFormBlock.map((block, i) =>
            index === i
              ? { ...block, companyid: null, companyvalue: null }
              : block
          )
        );
      }
    } else {
      if (value) {
        setTimeFormBlock(
          timeFormBlock.map((block, i) =>
            index === i ? { ...block, [field]: value } : block
          )
        );
      }
    }
  };

  //input data maping from details
  const updatedBlockData = (timeAvailibilityIds) => {
    const updatedLinkArr = timeAvailibilityIds.map((timeAvailibilityId) => {
      return {
        _id: timeAvailibilityId?._id,
        starttime: timeAvailibilityId?.starttime,
        endtime: timeAvailibilityId?.endtime,
        location: timeAvailibilityId?.location || "",
        companyid: timeAvailibilityId?.companyid?._id || null,
        companyvalue: timeAvailibilityId?.companyvalue,
      };
    });
    if (updatedLinkArr.length > 0) {
      setTimeFormBlock(updatedLinkArr);
      // Initialize validation for existing blocks
      setValidation(updatedLinkArr.map(() => ({ ...validationTemplate })));
    }
  };

  //get details
  const getDayAvailibilityDetails = async () => {
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_DAYS_AVAILIBILITY_DETAILS +
        `/${selectedDayId}?token=${token}`;

      const response = await getData(requestUrl);

      console.log(response);

      if (response.status) {
        setDayNameString(response.data.dayname);
        updatedBlockData(response.data.timeavailibilityids);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  // validate =========================
  const validate = () => {
    let overallIsValid = true;
    const newValidation = timeFormBlock.map((timeData, index) => {
      let blockIsValid = true;
      let currentBlockValidation = { ...validationTemplate };

      if (timeData.starttime === "") {
        currentBlockValidation.startTimeWarning = true;
        blockIsValid = false;
      }

      if (timeData.endtime === "") {
        currentBlockValidation.endTimeWarning = true;
        blockIsValid = false;
      }

      if (
        timeData.starttime !== "" &&
        timeData.endtime !== "" &&
        timeData.starttime > timeData.endtime
      ) {
        currentBlockValidation.timeDiffWarning = true;
        blockIsValid = false;
      }

      if (!blockIsValid) {
        overallIsValid = false;
      }
      return currentBlockValidation;
    });

    setValidation(newValidation);

    if (timeFormBlock.length === 0) {
      setTimeEmptyWarning(true);
      overallIsValid = false;
    } else {
      setTimeEmptyWarning(false);
    }

    return overallIsValid;
  };

  //save time
  const saveTimeAvailibilityHandler = async () => {
    if (validate()) {
      try {
        setIsSaving(true);
        let timeAvailibilityData = {
          configmode: autoFillConfig.configMode,
          dayavailibility: selectedDayId,
          timeavailbilities: timeFormBlock.map((block) => ({
            ...block,
            location: block.location || "",
            companyid: block.companyid || null,
          })),
        };

        let requestUrl =
          url.API_BASE_URL +
          url.API_ADD_TIME_AVAILIBILITY_OF_DAY +
          `?token=${token}`;

        const response = await postData(requestUrl, timeAvailibilityData);

        console.log(response);

        setIsSaving(false);

        if (response.status) {
          resetHandler();
          //hide modal
          let formModal = document.querySelector("#editTimeForDay");
          let modal = bootstrap.Modal.getInstance(formModal);
          modal.hide();

          afterModalClose();
        }
      } catch (error) {
        console.log(error.message);
      }
    }
  };

  //reset
  const resetHandler = () => {
    setTimeFormBlock([timeFormTemplate]);
    setselectedDayId(null);
    setValidation([validationTemplate]); // Reset validation for the initial block
    setTimeEmptyWarning(false);

    setAutoFillConfig({
      startTime: "09:00",
      endTime: "15:00",
      slotDuration: 30, // in minutes
      defaultLocation: "",
      defaultCompany: null,
      configMode: "new", // "new" or "existing"
    });
  };

  // Add auto-fill handler
  const handleAutoFill = () => {
    const {
      startTime,
      endTime,
      slotDuration,
      defaultLocation,
      defaultCompany,
      configMode,
    } = autoFillConfig;

    if (!startTime || !endTime) {
      return;
    }

    // Convert time strings to minutes for calculation
    const startMinutes = timeToMinutes(startTime);
    const endMinutes = timeToMinutes(endTime);

    if (startMinutes >= endMinutes) {
      return;
    }

    const slots = [];
    let currentStart = startMinutes;

    while (currentStart + slotDuration <= endMinutes) {
      const currentEnd = currentStart + slotDuration;

      slots.push({
        starttime: minutesToTime(currentStart),
        endtime: minutesToTime(currentEnd),
        location: defaultLocation || "",
        companyid: defaultCompany?.value || null,
        companyvalue: defaultCompany || null,
      });

      currentStart = currentEnd;
    }

    // Check config mode to decide whether to replace or append
    if (configMode === "new") {
      // Replace existing slots with new ones
      setTimeFormBlock(slots);
      setValidation(slots.map(() => ({ ...validationTemplate })));
    } else {
      // Append to existing slots
      setTimeFormBlock([...timeFormBlock, ...slots]);
      setValidation([
        ...validation,
        ...slots.map(() => ({ ...validationTemplate })),
      ]);
    }

    setTimeEmptyWarning(false);
  };

  // Helper function to convert time string to minutes
  const timeToMinutes = (timeStr) => {
    const [hours, minutes] = timeStr.split(":").map(Number);
    return hours * 60 + minutes;
  };

  // Helper function to convert minutes to time string
  const minutesToTime = (minutes) => {
    const hours = Math.floor(minutes / 60);
    const mins = minutes % 60;
    return `${hours.toString().padStart(2, "0")}:${mins
      .toString()
      .padStart(2, "0")}`;
  };

  useEffect(() => {
    if (selectedDayId) {
      getDayAvailibilityDetails();
    }
  }, [selectedDayId]);

  useEffect(() => {
    setTimeFormBlock([timeFormTemplate]);
    setValidation([validationTemplate]); // Initialize validation for the initial block
  }, []);

  return (
    <div
      className="modal fade"
      id="editTimeForDay"
      tabIndex="-1"
      aria-labelledby="editTimeForDay"
      aria-hidden="true"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
    >
      <div className="modal-dialog modal-xl modal-dialog-centered">
        <div className="modal-content bg-white border-0 rounded-15 shadow-lg">
          {/* Enhanced Header with Icon and Gradient Background */}
          <div className="modal-header bg-primary text-white p-4 pe-5 pb-3 border-bottom border-gray-300">
            <div className="d-flex align-items-center gap-3">
              <div className="icon-wrapper p-3 bg-white rounded-circle d-flex align-items-center justify-content-center">
                <span className="material-symbols-outlined text-primary fs-5 icon-md">
                  schedule
                </span>
              </div>
              <div>
                <h3
                  className="modal-title fw-bold text-white mb-0"
                  id="saveTimeModalLabel"
                >
                  {t("Save Time for")} {dayNameString}
                </h3>
                <p className="text-white fs-sm mb-0">
                  {t("Configure your availability schedule")}
                </p>
              </div>
            </div>
            <button
              type="button"
              className="btn-close p-1 bg-gray-200 rounded-circle shadow-sm border-0"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={resetHandler}
            ></button>
          </div>

          {/* Enhanced Modal Body */}
          <div
            className="modal-body p-4"
            style={{ backgroundColor: "var(--bs-gray-200)" }}
          >
            {/* Professional Card Layout */}
            <div className="p-3 p-md-4 border border-gray-300 rounded-15 shadow-sm bg-white">
              <form
                onSubmit={(e) => e.preventDefault()}
                className="d-flex flex-column h-100"
              >
                {/* Information Notice */}
                <div
                  className="alert alert-primary border-0 rounded-10 mb-4"
                  style={{
                    backgroundColor: "rgba(var(--bs-primary-rgb), 0.05)",
                    border: "1px solid rgba(var(--bs-primary-rgb), 0.15)",
                  }}
                >
                  {/* Header with Icon and Title */}
                  <div className="d-flex align-items-center gap-3 mb-3">
                    <div
                      className="p-2 bg-primary rounded-circle d-flex align-items-center justify-content-center"
                      style={{
                        width: "35px",
                        height: "35px",
                        backgroundColor: "var(--bs-primary)",
                      }}
                    >
                      <span className="material-symbols-outlined text-white fs-sm">
                        info
                      </span>
                    </div>
                    <h5
                      className="fw-bold mb-0"
                      style={{ color: "var(--bs-primary)", fontSize: "1.1rem" }}
                    >
                      {t("Time Slot Guidelines")}
                    </h5>
                  </div>

                  {/* Guidelines Text */}
                  <div className="mb-4 ps-5">
                    <p
                      className="fs-sm mb-2"
                      style={{ color: "var(--bs-primary)", opacity: "0.8" }}
                    >
                      {t(
                        "Configure your availability by setting time range and duration. Use auto-fill to quickly generate slots or add them manually."
                      )}
                    </p>
                    <ul
                      className="fs-sm mb-0"
                      style={{ color: "var(--bs-primary)", opacity: "0.7" }}
                    >
                      <li>
                        {t("Select start and end time for your working hours")}
                      </li>
                      <li>
                        {t("Choose slot duration (15, 30, 45, or 60 minutes)")}
                      </li>
                      <li>
                        {t(
                          "Set default location and clinic for all slots (optional)"
                        )}
                      </li>
                      <li>
                        {t("Click Auto Fill to generate slots automatically")}
                      </li>
                    </ul>
                  </div>

                  {/* Auto-fill Configuration */}
                  <div
                    className="p-4 rounded-10"
                    style={{
                      backgroundColor: "rgba(255, 255, 255, 0.6)",
                      border: "1px solid rgba(var(--bs-primary-rgb), 0.1)",
                    }}
                  >
                    <h6
                      className="fw-semibold mb-3 d-flex align-items-center gap-2"
                      style={{ color: "var(--bs-primary)" }}
                    >
                      <span className="material-symbols-outlined fs-sm">
                        tune
                      </span>
                      {t("Quick Setup Configuration")}
                    </h6>

                    {/* First Row - Time and Duration */}
                    <div className="row g-3 mb-3">
                      <div className="col-md-3">
                        <label
                          className="form-label fs-sm fw-semibold mb-1"
                          style={{ color: "var(--bs-primary)" }}
                        >
                          <span
                            className="material-symbols-outlined me-1"
                            style={{
                              fontSize: "0.9rem",
                              verticalAlign: "middle",
                            }}
                          >
                            tune
                          </span>
                          {t("Mode")}
                        </label>
                        <select
                          className="form-select form-select-sm shadow-none border"
                          style={{
                            borderRadius: "8px",
                            backgroundColor: "rgba(255, 255, 255, 0.9)",
                            fontSize: "0.85rem",
                            borderColor: "rgba(var(--bs-primary-rgb), 0.2)",
                          }}
                          value={autoFillConfig.configMode}
                          onChange={(e) =>
                            setAutoFillConfig((prev) => ({
                              ...prev,
                              configMode: e.target.value,
                            }))
                          }
                        >
                          <option value="new">{t("Add as new")}</option>
                          <option value="existing">
                            {t("Add with existing")}
                          </option>
                        </select>
                      </div>
                      <div className="col-md-2">
                        <label
                          className="form-label fs-sm fw-semibold mb-1"
                          style={{ color: "var(--bs-primary)" }}
                        >
                          <span
                            className="material-symbols-outlined me-1"
                            style={{
                              fontSize: "0.9rem",
                              verticalAlign: "middle",
                            }}
                          >
                            schedule
                          </span>
                          {t("Start Time")}
                        </label>
                        <input
                          type="time"
                          className="form-control form-control-sm shadow-none border"
                          style={{
                            borderRadius: "8px",
                            backgroundColor: "rgba(255, 255, 255, 0.9)",
                            fontSize: "0.85rem",
                            borderColor: "rgba(var(--bs-primary-rgb), 0.2)",
                          }}
                          value={autoFillConfig.startTime}
                          onChange={(e) =>
                            setAutoFillConfig((prev) => ({
                              ...prev,
                              startTime: e.target.value,
                            }))
                          }
                        />
                      </div>
                      <div className="col-md-2">
                        <label
                          className="form-label fs-sm fw-semibold mb-1"
                          style={{ color: "var(--bs-primary)" }}
                        >
                          <span
                            className="material-symbols-outlined me-1"
                            style={{
                              fontSize: "0.9rem",
                              verticalAlign: "middle",
                            }}
                          >
                            schedule
                          </span>
                          {t("End Time")}
                        </label>
                        <input
                          type="time"
                          className="form-control form-control-sm shadow-none border"
                          style={{
                            borderRadius: "8px",
                            backgroundColor: "rgba(255, 255, 255, 0.9)",
                            fontSize: "0.85rem",
                            borderColor: "rgba(var(--bs-primary-rgb), 0.2)",
                          }}
                          value={autoFillConfig.endTime}
                          onChange={(e) =>
                            setAutoFillConfig((prev) => ({
                              ...prev,
                              endTime: e.target.value,
                            }))
                          }
                        />
                      </div>
                      <div className="col-md-2">
                        <label
                          className="form-label fs-sm fw-semibold mb-1"
                          style={{ color: "var(--bs-primary)" }}
                        >
                          <span
                            className="material-symbols-outlined me-1"
                            style={{
                              fontSize: "0.9rem",
                              verticalAlign: "middle",
                            }}
                          >
                            timer
                          </span>
                          {t("Duration")}
                        </label>
                        <select
                          className="form-select form-select-sm shadow-none border"
                          style={{
                            borderRadius: "8px",
                            backgroundColor: "rgba(255, 255, 255, 0.9)",
                            fontSize: "0.85rem",
                            borderColor: "rgba(var(--bs-primary-rgb), 0.2)",
                          }}
                          value={autoFillConfig.slotDuration}
                          onChange={(e) =>
                            setAutoFillConfig((prev) => ({
                              ...prev,
                              slotDuration: parseInt(e.target.value),
                            }))
                          }
                        >
                          <option value={15}>15 {t("mins")}</option>
                          <option value={30}>30 {t("mins")}</option>
                          <option value={45}>45 {t("mins")}</option>
                          <option value={60}>60 {t("mins")}</option>
                        </select>
                      </div>
                      <div className="col-md-3 d-flex align-items-end">
                        <button
                          type="button"
                          className="btn btn-sm btn-primary d-flex align-items-center justify-content-center gap-2 px-4 py-2"
                          style={{
                            borderRadius: "8px",
                            fontSize: "0.85rem",
                            fontWeight: "600",
                            transition: "all 0.3s ease-in-out",
                            boxShadow:
                              "0 2px 8px rgba(var(--bs-primary-rgb), 0.2)",
                          }}
                          onClick={handleAutoFill}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.transform =
                              "translateY(-2px)";
                            e.currentTarget.style.boxShadow =
                              "0 4px 12px rgba(var(--bs-primary-rgb), 0.3)";
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.transform = "translateY(0)";
                            e.currentTarget.style.boxShadow =
                              "0 2px 8px rgba(var(--bs-primary-rgb), 0.2)";
                          }}
                        >
                          <span
                            className="material-symbols-outlined"
                            style={{ fontSize: "1rem" }}
                          >
                            auto_fix_high
                          </span>
                          {autoFillConfig.configMode === "new"
                            ? t("Replace & Fill")
                            : t("Append & Fill")}
                        </button>
                      </div>
                    </div>

                    {/* Second Row - Location and Clinic */}
                    <div className="row g-3">
                      <div className="col-md-4">
                        <label
                          className="form-label fs-sm fw-semibold mb-1"
                          style={{ color: "var(--bs-primary)" }}
                        >
                          <span
                            className="material-symbols-outlined me-1"
                            style={{
                              fontSize: "0.9rem",
                              verticalAlign: "middle",
                            }}
                          >
                            location_on
                          </span>
                          {t("Default Location")}{" "}
                          <span className="text-muted">({t("optional")})</span>
                        </label>
                        <input
                          type="text"
                          className="form-control form-control-sm shadow-none border"
                          style={{
                            borderRadius: "8px",
                            backgroundColor: "rgba(255, 255, 255, 0.9)",
                            fontSize: "0.85rem",
                            borderColor: "rgba(var(--bs-primary-rgb), 0.2)",
                          }}
                          placeholder={t("Enter default location")}
                          value={autoFillConfig.defaultLocation}
                          onChange={(e) =>
                            setAutoFillConfig((prev) => ({
                              ...prev,
                              defaultLocation: e.target.value,
                            }))
                          }
                        />
                      </div>
                      <div className="col-md-8">
                        <label
                          className="form-label fs-sm fw-semibold mb-1"
                          style={{ color: "var(--bs-primary)" }}
                        >
                          <span
                            className="material-symbols-outlined me-1"
                            style={{
                              fontSize: "0.9rem",
                              verticalAlign: "middle",
                            }}
                          >
                            business
                          </span>
                          {t("Default Company")}{" "}
                          <span className="text-muted">({t("optional")})</span>
                        </label>
                        <AsyncSelect
                          isClearable
                          name="defaultCompany"
                          loadOptions={loadCompanyOptions}
                          defaultOptions={false}
                          cacheOptions={false}
                          placeholder={t("Type company name for all slots")}
                          styles={{
                            control: (styles, { isFocused }) => ({
                              ...styles,
                              backgroundColor: "rgba(255, 255, 255, 0.9)",
                              border:
                                "1px solid rgba(var(--bs-primary-rgb), 0.2)",
                              borderRadius: "8px",
                              minHeight: "32px",
                              fontSize: "0.85rem",
                              boxShadow: "none",
                              padding: "4px",
                              "&:hover": {
                                borderColor: "rgba(var(--bs-primary-rgb), 0.3)",
                              },
                            }),
                            placeholder: (styles) => ({
                              ...styles,
                              fontSize: "0.85rem",
                            }),
                          }}
                          value={autoFillConfig.defaultCompany}
                          onChange={(value) => {
                            setAutoFillConfig((prev) => ({
                              ...prev,
                              defaultCompany: value,
                            }));
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="form-group d-flex mb-4">
                  <div className="field-group d-flex flex-column gap-3 flex-fill">
                    {/* <div className="d-flex align-items-center gap-2 mb-3">
                      <div
                        className="p-2 bg-primary rounded-circle d-flex align-items-center justify-content-center"
                        style={{ width: "35px", height: "35px" }}
                      >
                        <span className="material-symbols-outlined text-white fs-sm">
                          access_time
                        </span>
                      </div>
                      <label
                        htmlFor="timing"
                        className="d-block fs-md fw-bold text-dark mb-0"
                      >
                        {t("Time Slots")}
                      </label>
                    </div> */}

                    {timeFormBlock.map((timeData, index) => (
                      <div
                        className="field-container p-4 rounded-15 border border-gray-300 shadow-sm mb-4 position-relative"
                        key={index}
                      >
                        {/* Small delete icon on top-right corner */}
                        <div className="position-absolute top-0 end-0 p-2">
                          <Link
                            to="#"
                            onClick={() => onDeleteBlock(timeData, index)}
                            className="btn btn-outline-danger rounded-circle d-flex align-items-center justify-content-center"
                            style={{
                              width: "30px",
                              height: "30px",
                              flexShrink: 0,
                              transition: "all 0.3s ease-in-out",
                              backgroundColor: "transparent",
                              borderColor: "var(--bs-danger)",
                              color: "var(--bs-danger)",
                            }}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.transform = "scale(1.1)";
                              e.currentTarget.style.backgroundColor =
                                "var(--bs-danger)";
                              e.currentTarget.style.borderColor =
                                "var(--bs-danger)";
                              e.currentTarget.style.color = "white";
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.transform = "scale(1)";
                              e.currentTarget.style.backgroundColor =
                                "transparent";
                              e.currentTarget.style.borderColor =
                                "var(--bs-danger)";
                              e.currentTarget.style.color = "var(--bs-danger)";
                            }}
                          >
                            <span className="material-symbols-outlined fs-sm">
                              delete
                            </span>
                          </Link>
                        </div>

                        {/* 1st Row - Labels */}
                        <div className="row g-3 mb-2">
                          <div className="col-md-2">
                            <label className="d-block fs-sm fw-bold text-dark mb-0">
                              <span
                                className="material-symbols-outlined fs-sm me-1"
                                style={{ verticalAlign: "middle" }}
                              >
                                play_arrow
                              </span>
                              {t("Start Time")}
                            </label>
                          </div>
                          <div className="col-md-2">
                            <label className="d-block fs-sm fw-bold text-dark mb-0">
                              <span
                                className="material-symbols-outlined fs-sm me-1"
                                style={{ verticalAlign: "middle" }}
                              >
                                stop
                              </span>
                              {t("End Time")}
                            </label>
                          </div>
                          <div className="col-md-3">
                            <label className="d-block fs-sm fw-bold text-dark mb-0">
                              <span
                                className="material-symbols-outlined fs-sm me-1"
                                style={{ verticalAlign: "middle" }}
                              >
                                location_on
                              </span>
                              {t("Location")}
                            </label>
                          </div>
                          <div className="col-md-5">
                            <label className="d-block fs-sm fw-bold text-dark mb-0">
                              <span
                                className="material-symbols-outlined fs-sm me-1"
                                style={{ verticalAlign: "middle" }}
                              >
                                business
                              </span>
                              {t("Company")}
                            </label>
                          </div>
                        </div>

                        {/* 2nd Row - Input Fields */}
                        <div className="row g-3 mb-2">
                          <div className="col-md-2">
                            <input
                              type="time"
                              className={`form-control shadow-none fw-semibold border ${
                                validation[index]?.startTimeWarning
                                  ? "border-primary"
                                  : "border border-gray-300"
                              }`}
                              style={{
                                borderRadius: "10px",
                                padding: "12px 16px",
                                fontSize: "0.9rem",
                              }}
                              placeholder="Start Time"
                              value={timeData.starttime}
                              onChange={(e) =>
                                changeInputHandler(
                                  index,
                                  "starttime",
                                  e.target.value
                                )
                              }
                            />
                          </div>

                          <div className="col-md-2">
                            <input
                              type="time"
                              className={`form-control shadow-none fw-semibold border ${
                                validation[index]?.endTimeWarning ||
                                validation[index]?.timeDiffWarning
                                  ? "border-primary"
                                  : "border-gray-300"
                              }`}
                              style={{
                                borderRadius: "10px",
                                padding: "12px 16px",
                                fontSize: "0.9rem",
                              }}
                              placeholder="End Time"
                              value={timeData.endtime}
                              onChange={(e) =>
                                changeInputHandler(
                                  index,
                                  "endtime",
                                  e.target.value
                                )
                              }
                            />
                          </div>

                          {/* Location input */}
                          <div className="col-md-3">
                            <input
                              type="text"
                              className="form-control shadow-none border border-gray-300 fw-semibold"
                              style={{
                                borderRadius: "10px",
                                padding: "12px 16px",
                                fontSize: "0.9rem",
                              }}
                              placeholder={t("Enter location")}
                              value={timeData.location || ""}
                              onChange={(e) =>
                                changeInputHandler(
                                  index,
                                  "location",
                                  e.target.value
                                )
                              }
                            />
                          </div>

                          {/* Company select */}
                          <div className="col-md-5">
                            <AsyncSelect
                              isClearable
                              name="company"
                              loadOptions={loadCompanyOptions}
                              defaultOptions={false}
                              cacheOptions={false}
                              placeholder={t("Type company name")}
                              styles={{
                                control: (styles, { isFocused }) => ({
                                  ...styles,
                                  backgroundColor: "#ffffff",
                                  border: "1px solid #D4D4D4",
                                  borderRadius: "10px", // Border radius
                                  padding: "6px",
                                  boxShadow: "0 !important",
                                  "&:hover": {}, // Focus shadow effect
                                }),
                              }}
                              value={timeData.companyvalue}
                              onChange={(value) => {
                                if (value) {
                                  changeInputHandler(index, "company", value);
                                } else {
                                  changeInputHandler(index, "company", null);
                                }
                              }}
                            />
                          </div>
                        </div>

                        {/* 3rd Row - Validation Messages (only show if there are errors) */}
                        {(validation[index]?.startTimeWarning ||
                          validation[index]?.endTimeWarning ||
                          validation[index]?.timeDiffWarning) && (
                          <div className="row g-3 mt-1">
                            <div className="col-md-2">
                              {validation[index]?.startTimeWarning && (
                                <div
                                  className="alert alert-danger border-0 rounded-8 py-2 px-3 d-flex align-items-center gap-2"
                                  style={{
                                    fontSize: "0.75rem",
                                    margin: "0",
                                    width: "max-content",
                                  }}
                                >
                                  <span
                                    className="material-symbols-outlined"
                                    style={{ fontSize: "0.9rem" }}
                                  >
                                    warning
                                  </span>
                                  <span>Start time required!</span>
                                </div>
                              )}
                            </div>
                            <div className="col-md-2">
                              {validation[index]?.endTimeWarning && (
                                <div
                                  className="alert alert-danger border-0 rounded-8 py-2 px-3 d-flex align-items-center gap-2"
                                  style={{ fontSize: "0.75rem", margin: "0" }}
                                >
                                  <span
                                    className="material-symbols-outlined"
                                    style={{ fontSize: "0.9rem" }}
                                  >
                                    warning
                                  </span>
                                  <span>End time required!</span>
                                </div>
                              )}
                              {validation[index]?.timeDiffWarning && (
                                <div
                                  className="alert alert-danger border-0 rounded-8 py-2 px-3 d-flex align-items-center gap-2 mt-1"
                                  style={{ fontSize: "0.75rem", margin: "0" }}
                                >
                                  <span
                                    className="material-symbols-outlined"
                                    style={{ fontSize: "0.9rem" }}
                                  >
                                    warning
                                  </span>
                                  <span>
                                    End time should not be less than start time!
                                  </span>
                                </div>
                              )}
                            </div>
                            <div className="col-md-3">
                              {/* Location validation can be added here if needed */}
                            </div>
                            <div className="col-md-5">
                              {/* Company column - no validation needed */}
                            </div>
                          </div>
                        )}
                      </div>
                    ))}

                    {/* Empty warning with enhanced styling */}
                    {timeEmptyWarning && (
                      <div className="error-message mt-3">
                        <div
                          className="alert alert-warning border-0 rounded-10 d-flex align-items-center gap-3"
                          style={{
                            backgroundColor: "rgba(251, 187, 33, 0.1)",
                            border: "1px solid rgba(251, 187, 33, 0.3)",
                          }}
                        >
                          <div
                            className="p-2 bg-warning rounded-circle d-flex align-items-center justify-content-center"
                            style={{ width: "40px", height: "40px" }}
                          >
                            <span className="material-symbols-outlined text-white fs-sm">
                              warning
                            </span>
                          </div>
                          <div>
                            <p className="fw-semibold mb-1 text-warning">
                              {t("No Time Slots Added")}
                            </p>
                            <p className="fs-sm mb-0 text-warning">
                              {t(
                                "Please add time block by clicking plus icon!"
                              )}
                            </p>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>

                {/* Enhanced Action Buttons */}
                <div className="action d-flex align-items-center justify-content-between mt-4 pt-3 border-top border-gray-300">
                  <button
                    className="btn btn-outline-primary p-3 d-inline-flex align-items-center gap-2 rounded-15"
                    onClick={addNewTimeBlock}
                    style={{
                      transition: "all 0.3s ease-in-out",
                      fontWeight: "600",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = "scale(1.05)";
                      e.currentTarget.style.backgroundColor =
                        "var(--bs-primary)";
                      e.currentTarget.style.color = "white";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = "scale(1)";
                      e.currentTarget.style.backgroundColor = "transparent";
                      e.currentTarget.style.color = "var(--bs-primary)";
                    }}
                  >
                    <span className="material-symbols-outlined fs-md">
                      add_circle
                    </span>
                    <span>{t("Add Time Slot")}</span>
                  </button>

                  <button
                    type="button"
                    className="btn btn-primary p-3 rounded-15 fw-bold d-inline-flex align-items-center gap-2"
                    onClick={saveTimeAvailibilityHandler}
                    style={{
                      transition: "all 0.3s ease-in-out",
                      fontSize: "1rem",
                      cursor: isSaving ? "not-allowed" : "pointer",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = "scale(1.05)";
                      e.currentTarget.style.boxShadow =
                        "0 8px 25px rgba(238, 82, 60, 0.3)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = "scale(1)";
                      e.currentTarget.style.boxShadow = "none";
                    }}
                    disabled={isSaving}
                  >
                    <span className="material-symbols-outlined fs-md">
                      save
                    </span>
                    {isSaving ? (
                      <>
                        <span
                          className="spinner-border spinner-border-sm me-2"
                          role="status"
                        >
                          <span className="visually-hidden">Loading...</span>
                        </span>
                        <span>{t("Saving...")}</span>
                      </>
                    ) : (
                      <span>{t("Save Schedule")}</span>
                    )}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SaveTimeModal;
